import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import VueGoogleMaps from '@fawmi/vue-google-maps'

createApp(App).use(router).use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAp_7Pqb7Lhu_UJCi7f3BzPDpSg1mB6sVs',
    },
}).mount('#app')

